import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import { FaUsers, FaEuroSign, FaShoppingBag, FaDollarSign } from 'react-icons/fa';
import { GrLineChart } from "react-icons/gr";
import { Apis } from "../../config";

import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

const Dashboard = () => {
  const [data, setData] = useState(null);

  const firstDayOfMonth = new Date();
  firstDayOfMonth.setDate(1);
  firstDayOfMonth.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);


  const [startDate, setStartDate] = useState(new Date(firstDayOfMonth));
  const [endDate, setEndDate] = useState(new Date(today));

  useEffect(() => {
    fetch(
      `${Apis.GetDashboard}?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    )
      .then((res) => res.json())
      .then((result) => setData(result.dashboardData))
      .catch((err) => console.error(err));
  }, [startDate, endDate]);

  if (!data) return <p>Loading...</p>;

  // Prepare chart data
  const labels = data.trend.map((item) => item.date);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Sessions",
        data: data.trend.map((item) => item.dailySessions),
        borderColor: "#4F46E5",
        backgroundColor: "rgba(79, 70, 229, 0.2)",
        fill: true,
        tension: 0.3,
        yAxisID: "y",
      },
      {
        label: "Orders",
        data: data.trend.map((item) => item.dailyOrders || 0),
        borderColor: "#16A34A",
        backgroundColor: "rgba(22, 163, 74, 0.2)",
        fill: true,
        tension: 0.3,
        yAxisID: "y",
      },
      {
        label: "Sales (£)",
        data: data.trend.map((item) => item.dailySales || 0),
        borderColor: "#9333EA",
        backgroundColor: "rgba(147, 51, 234, 0.2)",
        fill: true,
        tension: 0.3,
        yAxisID: "y1", 
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "Sessions / Orders",
        },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        title: {
          display: true,
          text: "Sales (£)",
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
       <div className='innerPageWrapper'>
         <Container fluid="md">
        <div className="chart-header d-flex align-items-center gap-2 mb-3">
           <DatePicker value={startDate} onChange={(date) => setStartDate(date)} clearIcon={null}/>
           <DatePicker value={endDate} onChange={(date) => setEndDate(date)} clearIcon={null} />
        </div>

       <Row>
              <Col xs={4} md={3}>
                 <Card className='tiles-item tiles-success'>
                  <Card.Body>                     <div className='d-flex justify-content-between'>
                      <div className='mt-2'>
                        <h6>Sessions</h6>
                         <h2 style={{fontSize:20}}>{data?.totalSessions}</h2>
                      </div>
                      <div className='tilesIcon'>
                        <FaUsers />
                       </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
             
              <Col xs={4} md={3}>
                <Card className='tiles-item tiles-success'>
                  <Card.Body>
                    <div className='d-flex justify-content-between'>
                     <div className='mt-2'>
                       <h6>Total Sales</h6>
                       <h2 style={{fontSize:20}}>£ {data?.totalSales}</h2>
                      </div>
                       <div className='tilesIcon'>
                        <FaEuroSign />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
                <Col xs={4} md={3}>
                 <Card className='tiles-item tiles-success'>
                   <Card.Body>
                     <div className='d-flex justify-content-between'>
                       <div className='mt-2'>
                         <h6>Orders</h6>
                       <h2 style={{fontSize:20}}>{data?.totalOrders}</h2>
                       </div>
                       <div className='tilesIcon'>
                         <FaShoppingBag />
                       </div>
                     </div>
                   </Card.Body>
                 </Card>
               </Col>
               <Col xs={4} md={3}>
                 <Card className='tiles-item tiles-success'>
                   <Card.Body>
                     <div className='d-flex justify-content-between'>
                       <div className='mt-2'>
                         <h6>Conversion rate</h6>
                       <h2 style={{fontSize:20}}>{data?.conversionRate}%</h2>
                       </div>
                       <div className='tilesIcon'>
                         <GrLineChart />
                       </div>
                     </div>
                   </Card.Body>
                 </Card>
               </Col>
             </Row>


      {/* Chart */}
      <div className="bg-white p-6 rounded shadow mt-3">
       
  
   
         <Line data={chartData} options={options} style={{width:'100%'}}/>
      </div>
      </Container>
    </div>
  );
};

export default Dashboard;
